import keyBy from 'lodash/keyBy';
import type { FormEvent } from 'react';
import { Component } from 'react';
import { Col, ControlLabel, Form, FormControl, FormGroup, Row } from 'react-bootstrap';

import type { Project, ProjectGroupReleaseProject } from '../../../../types';
import ProjectGroupListTable from '../components/ProjectGroupListTable';
import ProjectGroupReleaseProjectsTable from '../components/ProjectGroupReleaseProjectsTable';
import ProjectGroupReleaseProjectsTableHeader from '../components/ProjectGroupReleaseProjectsTableHeader';
import ProjectGroupReleaseTitleInput from '../components/ProjectGroupReleaseTitleInput';

type CreateProjectGroupProps = {
  title: string;
  release: string;
  setTitle: (title: string) => void;
  setRelease: (release: string) => void;
  projects: Project[];
  releaseProjects: ProjectGroupReleaseProject[];
  onAddProject: (project: Project) => void;
  onRemoveProject: (project: Project) => void;
  onUpdateProject: (project: Project) => void;
};

type CreateProjectGroupState = {
  showSelectProjects: boolean;
};

class CreateProjectGroup extends Component<CreateProjectGroupProps, CreateProjectGroupState> {
  state = {
    showSelectProjects: this.props.releaseProjects.length === 0,
  };

  setRelease = (e: FormEvent<FormControl>) => {
    const el = e.target as HTMLInputElement;
    this.props.setRelease(el.value);
  };

  setTitle = (e: FormEvent<FormControl>) => {
    const el = e.target as HTMLInputElement;
    this.props.setTitle(el.value);
  };

  showSelectProjects = () => {
    this.setState({ showSelectProjects: true });
  };

  render() {
    const { releaseProjects = [], title = '', release = '' } = this.props;
    const selectedProjectLocators = keyBy(releaseProjects, (project) => project.locator);
    const projects = this.props.projects.filter(
      project => project.locator && !selectedProjectLocators[project.locator],
    );

    return (
      <div className="select-projects">
        <Form>
          <Row>
            <Col xs={12}>
              <h4>1. Group Details</h4>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <FormGroup>
                <ControlLabel className="text-label">Title</ControlLabel>
                <FormControl
                  type="text"
                  value={title}
                  onChange={this.setTitle}
                  placeholder="New Release Group"
                />
              </FormGroup>
            </Col>
            <Col xs={6}>
              <ProjectGroupReleaseTitleInput
                title={release}
                onChangeTitle={this.setRelease}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '10px' }}>
            <Col xs={12}>
              <h4>2. Select Projects</h4>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ProjectGroupReleaseProjectsTableHeader
                releaseProjects={this.props.releaseProjects}
                showSelectProjects={this.state.showSelectProjects}
                onShowSelectProjects={this.showSelectProjects}
                onUpdateProject={this.props.onUpdateProject}
              />
              {
                releaseProjects.length === 0 ? (
                  <div className="card-body">
                    <div className="no-projects">
                      <h4>No Projects</h4>
                      <p>
                        This release does not contain any projects<br />
                        yet. Add some below.
                      </p>
                    </div>
                  </div>
                ) : (
                  <ProjectGroupReleaseProjectsTable
                    onProjectSelected={this.props.onRemoveProject}
                    onUpdateProject={this.props.onUpdateProject}
                    releaseProjects={releaseProjects}
                    editMode={false}
                    createMode
                  />
                )
              }
            </Col>
          </Row>
          {
            this.state.showSelectProjects && (
              <div>
                <Row>
                  <Col xs={12}>
                    <p className="text-label">All Projects</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <ProjectGroupListTable
                      showHeader
                      onProjectSelected={this.props.onAddProject}
                      projects={projects}
                    />
                  </Col>
                </Row>
              </div>
            )
          }
        </Form>
      </div>
    );
  }
}

export default CreateProjectGroup;
